import { actions, types } from './requests'
export const GETDOCUMENTRECAP_TYPES = {
    ...types('GETDOCUMENTRECAP'),
}
export const GETDOCUMENTRECAP_ACTIONS = {
    ...actions('GETDOCUMENTRECAP'),
}
